function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M12.5 25C5.59644 25 -1.69631e-06 19.4036 -1.09278e-06 12.5C-1.07534e-06 12.3005 0.00467385 12.102 0.0139226 11.9048L-1.04075e-06 11.9048L0 -2.78221e-07L11.9048 7.62527e-07L11.9048 0.0139235C12.102 0.00467622 12.3005 7.9712e-07 12.5 8.14564e-07C19.4036 1.41809e-06 25 5.59644 25 12.5C25 19.4036 19.4036 25 12.5 25Z",
  fill: "#FAB100"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.6001 13.5985H14.8001H29.2001H30.4001V16H29.2001H14.8001H13.6001V13.5985ZM13.6001 20.798H14.8001H24.4001H25.6001V23.1995H24.4001H14.8001H13.6001V20.798Z",
  fill: "#FAB100"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.6 30.399V31.5998V36.3988L21.28 30.6392L21.5992 30.399H22H36.4C37.0648 30.399 37.6 29.8635 37.6 29.1983V7.60216C37.6 6.93696 37.0648 6.40144 36.4 6.40144H7.6C6.9352 6.40144 6.4 6.93696 6.4 7.60216V29.1983C6.39968 29.3561 6.43051 29.5124 6.4907 29.6582C6.55089 29.804 6.63927 29.9365 6.75077 30.0481C6.86226 30.1596 6.99467 30.2481 7.14041 30.3083C7.28614 30.3685 7.44233 30.3994 7.6 30.399H12.4H13.6ZM40 29.1983V7.60216C40 5.60897 38.3896 4 36.4 4H7.6C5.6104 4 4 5.60897 4 7.60216V29.1983C4 31.1915 5.6104 32.8005 7.6 32.8005H11.2V38.7993C11.2 39.0223 11.2621 39.2408 11.3792 39.4305C11.4964 39.6202 11.664 39.7735 11.8633 39.8732C12.0627 39.973 12.2858 40.0152 12.5078 39.9951C12.7297 39.9751 12.9417 39.8937 13.12 39.7599L22.3998 32.8005H36.4C38.3888 32.8005 39.9987 31.1928 40 29.2007C40 29.1999 40 29.1991 40 29.1983Z",
  fill: "#0E185B"
});

var SvgMessage = function SvgMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message.97273e68.svg";
export { ForwardRef as ReactComponent };